import React from 'react';
import PropTypes from 'prop-types';

const TitleMain = props => {
  let borderLeft;
  if (props.datos.value.risk.toUpperCase() === 'HIGHRISK') {
    borderLeft = `HIGHRISK main_title_new`;
  } else if (props.datos.value.risk.toUpperCase() === 'LOWRISK') {
    borderLeft = `OUTOFRISK main_title_new`;
  } else {
    borderLeft = `MIDDLERISK main_title_new`;
  }

  return (
    <section className={`${borderLeft}`}>
      <h1>{props.language.summary.nfa.title}</h1>
    </section>
  );
};

export default TitleMain;



// WEBPACK FOOTER //
// ./source/client/components/summary_nfa/title.jsx